import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';

import type RoomControlConfigurationModel from 'admin-panel/models/room-control/configuration';
import type RoomControlIrCodeSetModel from 'admin-panel/models/room-control/ir-code-set';

export default class RoomControlIrDeviceModel extends Model {
  @belongsTo('room-control/configuration')
  declare roomControlConfiguration: AsyncBelongsTo<RoomControlConfigurationModel>;

  @belongsTo('room-control/ir-code-set')
  declare roomControlIrCodeSet: AsyncBelongsTo<RoomControlIrCodeSetModel>;

  @attr
  declare deviceType: string;

  @attr
  declare label: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/ir-device': RoomControlIrDeviceModel;
  }
}
